var map = {
	"./da/resource.json": [
		"f2dd",
		"lang-da-resource-json"
	],
	"./de/resource.json": [
		"a2a5",
		"lang-de-resource-json"
	],
	"./en/resource.json": [
		"de92",
		"lang-en-resource-json"
	],
	"./es/resource.json": [
		"41c3",
		"lang-es-resource-json"
	],
	"./fr/resource.json": [
		"c266",
		"lang-fr-resource-json"
	],
	"./pl/resource.json": [
		"10a6",
		"lang-pl-resource-json"
	],
	"./tr/resource.json": [
		"2ad3",
		"lang-tr-resource-json"
	],
	"./zh/resource.json": [
		"ad79",
		"lang-zh-resource-json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "72a9";
module.exports = webpackAsyncContext;